/* <jp-product-carousel> — arrow navigation for a scrolling product list
   (sections/jp-featured-products.liquid). The theme's <product-list> already
   scrolls .product-list__inner when an arrow is pressed, but it only refreshes
   the arrows' disabled state on click, so dragging or swiping the list leaves
   them stale — and a stale disabled arrow is a dead button. This keeps them in
   sync with the real scroll position, which also hides both arrows when there
   is nothing to scroll (fewer products than fit on screen). */

if (!customElements.get("jp-product-carousel")) {
  customElements.define(
    "jp-product-carousel",
    class JPProductCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector(".product-list__inner");
        /* The buttons are queried directly rather than through the
           <prev-next-buttons> setters: this element can upgrade before that
           one does, and assigning to isPrevDisabled/isNextDisabled too early
           would shadow the setters with own properties. */
        this.prevButton = this.querySelector(".prev-next-button--prev");
        this.nextButton = this.querySelector(".prev-next-button--next");

        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.track.addEventListener("scroll", () => this.updateButtons(), {
          passive: true,
        });

        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);

        this.updateButtons();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      updateButtons() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        /* scrollLeft runs negative in RTL. */
        const scrollLeft = Math.abs(this.track.scrollLeft);

        this.prevButton.toggleAttribute("disabled", scrollLeft < 1);
        this.nextButton.toggleAttribute(
          "disabled",
          scrollLeft >= maxScroll - 1,
        );
      }
    },
  );
}
